import { UserRound, Search } from "lucide-react";

// Why a Partner / Customer row matched the search — shown when it wasn't the name.
export function SearchMatchHint({ match, testid }) {
  if (!match) return null;
  const isUser = match.kind === "user";
  const Icon = isUser ? UserRound : Search;
  return (
    <div className="mt-0.5 flex min-w-0 max-w-[280px] items-center gap-1 text-[11px] text-amber-700" data-testid={testid}>
      <Icon className="h-3 w-3 shrink-0" />
      <span className="shrink-0 font-medium">{isUser ? "Matched user:" : `Matched ${match.label.toLowerCase()}:`}</span>
      <span className="truncate text-slate-600" title={match.value}>
        {isUser && match.user_name && match.user_name !== match.value ? `${match.user_name} · ${match.value}` : match.value}
      </span>
      {isUser && match.more > 0 && <span className="shrink-0 text-slate-400">+{match.more} more</span>}
    </div>
  );
}
